import React from "react";
import styles from "./ProrationSummaryModal.module.css";

const ProrationSummaryModal = ({ open, invoice, onClose, onConfirm, currentSubcriptionplain }) => {
  if (!open) return null;

  const trialEnd = new Date(currentSubcriptionplain.expirationDate);
  const now = new Date();
  const msPerDay = 1000 * 60 * 60 * 24;
  const daysLeft = Math.ceil((trialEnd - now) / msPerDay);

  // If still in trial period, show trial notice modal
  if (trialEnd > now) {
    return (
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <h2>You're in a Trial Period</h2>
          <p>
            Your current plan is in a free trial until <strong>{trialEnd.toDateString()}</strong>.
          </p>
          <p>You have <strong>{daysLeft}</strong> day{daysLeft !== 1 ? 's' : ''} left in your trial.</p>
          <p>You can change your subscription plan after the trial period ends.</p>
          <div className={styles.actions}>
            <button onClick={onClose} className={styles.cancelBtn}>OK</button>
          </div>
        </div>
      </div>
    );
  }

  if (!invoice) return null;

  const {
    amountDue,
    subtotal,
    startingBalance,
    summary,
    lines,
    currency,
  } = invoice;

  const formatAmount = (amount) =>
    `${amount < 0 ? "-" : ""}${currency} ${Math.abs(amount).toFixed(2)}`;

  const isUnusedTimeRefund = (description) => {
    return description.toLowerCase().includes('unused') ||
           description.toLowerCase().includes('refund') ||
           description.toLowerCase().includes('credit');
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Confirm changes</h2>

        {lines.map((line, index) => (
          <div key={index} className={styles.lineItem}>
            <span>{line.description}</span>
            <span className={isUnusedTimeRefund(line.description) ? styles.unused : ''}>
              {formatAmount(line.amount)}
            </span>
          </div>
        ))}

        <div className={styles.lineItem}>
          <span>Subtotal</span>
          <span>{currency} {subtotal.toFixed(2)}</span>
        </div>

        <div className={styles.lineItem}>
          <span>Available Stripe Credit</span>
          <span className={styles.credit}>
            -{currency} {Math.abs(startingBalance).toFixed(2)}
          </span>
        </div>

        <hr />

        <div className={styles.lineItem}>
          <strong>Total due today</strong>
          <strong>{currency} {amountDue.toFixed(2)}</strong>
        </div>

        <p className={styles.summaryNote}>{summary.label}</p>
        <p className={styles.reasonNote}>{summary.reason}</p>

        <div className={styles.actions}>
          <button onClick={onClose} className={styles.cancelBtn}>
            Cancel
          </button>
          <button onClick={onConfirm} className={styles.payBtn}>
            {amountDue > 0 ? "Pay now" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProrationSummaryModal;
